import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import EndOfDayFormColumn from '../../components/columns/end-of-day-form-column';
import { printEndOfDayForms } from '../../store/printing/print.actions';
import { doesCarrierAutoGenerateEod, doesCarrierUseElectronicEod } from './carrier-eod-helper';
import Global from '../../store/global-selectors';

export const EndOfDayFormColumnContainer = ({ fulfillmentId }) => {
  const dispatch = useDispatch();

  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelCreatedDateTime, eodFormId, carrierId } = labelFulfillment ?? {};

  const onLinkClicked = useCallback(() => {
    dispatch(printEndOfDayForms([eodFormId]));
  }, [eodFormId, dispatch]);

  return (
    <EndOfDayFormColumn
      eodFormId={eodFormId}
      isEodAutoGenerated={doesCarrierAutoGenerateEod(carrierId)}
      isEodElectronic={doesCarrierUseElectronicEod(carrierId)}
      isLabelCreated={labelCreatedDateTime != null}
      onLinkClicked={onLinkClicked}
    />
  );
};

EndOfDayFormColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
